import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const GrievanceRedressalMechanism = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Grievance Redressal Mechanism"
        description="Official procedure for lodging grievances against stock brokers, depository participants, and listed companies. Detailed escalation matrix and SEBI SCORES information."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas" aria-hidden="true"></canvas>
              <div className="carousel-caption">
                <h1>Grievance Redressal Mechanism</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h3>Grievance Against Stock Broker / Depository Participant</h3>
              <h5>Dear Investor,</h5>
              <p>
                In case of any grievance / complaint against the Stock Broker /
                Depository Participant:
              </p>
              <ul className="listitem">
                <li>
                  Please contact Compliance Officer of the Stock Broker/
                  Depository Participant
                </li>
                <li>You may also approach CEO </li>
                <li>
                  If not satisfied with the response of the Stock Broker/
                  Depository Participant, you may contact the concerned Stock
                  Exchange / Depository at following:
                </li>
              </ul>

              <div className="table-responsive">
                <table className="table dwn-tbl table-bordered con_tbl">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Name of Stock Exchange/Depository</th>
                      <th scope="col">Contact Telephone Nos.</th>
                      <th scope="col">Contact E-mail ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Bombay Stock Exchange Limited</td>
                      <td>(91 22) 2272 8517 / 8097</td>
                      <td>
                        <a href="mailto:dis@bseindia.com">dis@bseindia.com</a>
                      </td>
                    </tr>
                    <tr>
                      <td>National Stock Exchange of India Ltd.</td>
                      <td>(91 22) 2659 8190 / 91 / 1800 266 058</td>
                      <td>
                        <a href="mailto:ignse@nse.co.in">ignse@nse.co.in</a>
                      </td>
                    </tr>
                    <tr>
                      <td>Central Depository Services (India) Limited</td>
                      <td>1800-200-5533</td>
                      <td>
                        <a href="mailto:complaints@cdslindia.com">
                          complaints@cdslindia.com
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>National Securities Depository Limited</td>
                      <td>(91 22) 2499 4200</td>
                      <td>
                        <a href="mailto:relations@nsdl.co.in">
                          relations@nsdl.co.in
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>Multi Commodity Exchange of India Limited</td>
                      <td>(91 22) 6649 4040</td>
                      <td>
                        <a href="mailto:grievance@mcxindia.com">
                          grievance@mcxindia.com
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>Indian Commodity Exchange Limited</td>
                      <td>(91 22) 4038 1546</td>
                      <td>
                        <a href="mailto:grievance@icexindia.com">
                          grievance@icexindia.com
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p>
                You can also lodge your grievances with SEBI at{" "}
                <a
                  href="https://scores.gov.in"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  https://scores.gov.in
                </a>
                . For any queries, feedback or assistance, please contact SEBI
                Office on Toll Free Helpline at 1800 22 7575.
              </p>

              <h5>
                Grievances against a listed company or intermediary registered
                with SEBI
              </h5>
              <p>
                In case you have grievances against a listed company or
                intermediary registered with SEBI, you should first approach the
                concerned company or intermediary shown above, giving details.
                If you are not satisfied with their response, you may approach
                SEBI or other regulatory bodies. You can approach SEBI for
                following types of grievances:
              </p>

              <h5>a. Listed Companies:</h5>
              <ul className="listitem">
                <li>Refund/Allotment</li>
                <li>Bonus/Dividend/Rights/Redemption/Interest</li>
                <li>Prelisting offer documents (shares)</li>
                <li>Prelisting offer documents (debentures and bonds)</li>
                <li>Delisting of Securities</li>
                <li>Buyback of Securities</li>
                <li>Takeover and Restructuring</li>
                <li>Corporate Governance and Listing Conditions</li>
              </ul>

              <h5>b. Stock brokers or stock exchanges:</h5>
              <ul className="listitem">
                <li>Stock brokers</li>
                <li>Sub brokers</li>
                <li>Portfolio managers</li>
                <li>Stock exchanges</li>
              </ul>

              <h5>c. Registrar and Transfer Agents</h5>
              <h5>d. Mutual Funds</h5>
              <h5>e. Depository and Depository participants</h5>
              <h5>f. Other entities:</h5>
              <ul className="listitem">
                <li>Collective Investment Schemes</li>
                <li>Debenture Trustees</li>
                <li>Merchant Bankers</li>
                <li>Bankers to Issues</li>
                <li>Credit Rating Agencies</li>
                <li>Custodian of Securities</li>
                <li>Foreign Institutional Investors</li>
                <li>Underwriters</li>
                <li>Venture Capital Funds</li>
                <li>KYC Registration Agency (KRA)</li>
                <li>Alternative Investment Fund</li>
              </ul>

              <h5>g. Information to SEBI:</h5>
              <ul className="listitem">
                <li>Price Manipulation</li>
                <li>Insider trading</li>
              </ul>

              <p>
                You can file your complaints online at:{" "}
                <a
                  href="https://scores.gov.in"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  https://scores.gov.in
                </a>{" "}
                or alternately send your complaints to Office of Investor
                Assistance and Education of SEBI at Mumbai or Regional Offices
                at the following addresses:
              </p>
              <p>
                <b>Office of Investor Assistance and Education -</b> SEBI
                Bhavan, Plot No. C4-A, ‘G’ Block, Bandra Kurla Complex, Bandra
                (E), Mumbai 400 051 / Tel: 022-26449188 / 26449919 /{" "}
                <a
                  href="https://scores.gov.in"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  https://scores.gov.in
                </a>
              </p>
              <p>
                <b>SEBI, Northern Regional Office -</b> 5th Floor, Bank of
                Baroda Building, 16, Sansad Marg, New Delhi - 110 001/ Tel:
                011-23724001-05 /{" "}
                <a href="mailto:sebinro@sebi.gov.in">sebinro@sebi.gov.in</a>
              </p>
              <p>
                <b>SEBI, Eastern Regional Office -</b> L&amp;T Chambers, 3rd
                Floor, 16, Camac Street, Kolkata - 700 016 / Tel: 033-22302300 /{" "}
                <a href="mailto:sebiero@sebi.gov.in">sebiero@sebi.gov.in</a>
              </p>
              <p>
                <b>SEBI, Southern Regional Office -</b> 7th Floor, Overseas
                Towers, 756-L, Anna Salai, Chennai - 600 002 / Tel: 044-24674000
                / 24674150 /{" "}
                <a href="mailto:sebisro@sebi.gov.in">sebisro@sebi.gov.in</a>
              </p>
              <p>
                <b>SEBI, Ahmedabad Regional Office -</b> Office Unit No. 002,
                Ground Floor, SAKAR I, Near Nehru Bridge Ashram Road, Ahmedabad
                - 380 009 / Tel: 079-26583633-35 /{" "}
                <a href="mailto:sebiao@sebi.gov.in">sebiao@sebi.gov.in</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/app-pic.jpg"
                className="img-fluid"
                alt="Mobile App Preview"
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default GrievanceRedressalMechanism;
